
import { IInvoice } from "@/interfaces/mlm";
import {
  dispatchPhysicalNodeConfirmInvoice,
  dispatchPhysicalNodePurchaseRequest,
  dispatchGetReferralConfirmation,
  dispatchGetPhysicalNodesActive
} from "@/store/mlm/actions";
import { Component, Vue, Prop } from "vue-property-decorator";
import { readUserProfile } from "@/store/main/getters";
import ChangeEmailModal from "@/components/Main/ChangeEmailModal.vue";
import UiSmallLoader from "@/components/Main/Ui/UiSmallLoader.vue";
@Component({
  components: { UiSmallLoader, ChangeEmailModal},
})
export default class PhysicalNodesPaymentModal extends Vue {
  // @ts-ignore
  @Prop({ required: true, default: false }) public readonly modalShow: boolean;
  // @ts-ignore
  @Prop({ required: true, default: null }) public readonly pack: any;

  public loadingState: any = {
    standart: false,
    submit: false,
  };
  public paymentMethod: string = "wallet";
  public standart: string = "";
  public invoiceDetail: IInvoice | null = null;
  public transaction: any = null;
  public progressPercent = 100;
  public timeToReload = 15;
  public isModalClosed: boolean = false;
  // public isShowModalByTariffFromDexNetToken: boolean = false
  public myReferral: any = null
  public isChecked = false
  public invoiceId = null as number | null
  public errorMessage = ""
  public purchaseRequest = null

  public async mounted() {
    // by default USDT request Invoice on mounted and get amount if DexNet for priceDexnet
    await this.requestInvoice("USDT");
     await this.informationMy()
  }

  // Methods

  public async informationMy() {
    const result = await dispatchGetReferralConfirmation(this.$store)

    if (result && !result.success === false) {
      this.myReferral = result.data
      return result;
    } else {
      this.$toast.error("Failed to get referral information, please try again later", {
        message: "Failed to get referral information, please try again later",
        duration: 3000,
        position: "bottom",
      });
      return null;
    }
  }

  public async handleProcessPayment() {
    if(!this.isChecked) return;

    this.loadingState.submit = true
    this.errorMessage = ""

    if (this.invoiceId) {
      if(this.paymentMethod === 'wallet'){
        const payload = {
          invoice: this.invoiceId,
          email: this?.userProfile?.email,
          period: 1
        }
        const result = await dispatchPhysicalNodeConfirmInvoice(this.$store, payload);

        if (result && result.success) {
          this.$toast.success(this.$t('successfully').toString())
          // update physical nodes list
          await dispatchGetPhysicalNodesActive(this.$store);
          this.closeModal()
        } else if (result.status === 400) {
          if (result.data?.email)  this.errorMessage = this.$t("Invalid email").toString()
          if (result.data?.detail) this.errorMessage = this.$t('This package is temporarily unavailable').toString()
          if (result.data?.invoice)  this.errorMessage = this.$t('Insufficient funds').toString()
          this.$toast.error(this.$t("ERROR").toString() + ": " + this.errorMessage);
        } else {
          this.$toast.error(this.$t("ERROR").toString())
        }
        this.loadingState.submit = false
      } 
    }
  }

  public needSomeMoney() {
  
    const balance = this.userProfile
        ? Number(this.userProfile.balances.units_total)
        : 0;
    const r = Math.abs(balance - this.pack.usdt_price)
    return Math.round(r);
    
  }
  


  public closeModal() {
    this.isModalClosed = true;
    this.$emit("close-modal");
  }

 

  public async requestInvoice(token: string) {
    const result = await dispatchPhysicalNodePurchaseRequest(this.$store, {
    physical_node: this.pack.id,
    standart: "BEP20",
    token: token
  });

  if (result && result.data.invoice) {
    const invoiceData = result.data.invoice;
    if(invoiceData.id) {
      this.invoiceId = invoiceData.id;
    }
  } else {
    this.$toast.error("Error");
  }
  }


  get userProfile() {
    return readUserProfile(this.$store);
  }
}
